// src/components/Control/ZenohSettings.tsx
import React from 'react';
import { ZenohSettings as ZenohSettingsType } from '../../../types';

interface ZenohSettingsProps {
  settings: ZenohSettingsType;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSave: () => void; // Добавлен обработчик сохранения
}

const ZenohSettings: React.FC<ZenohSettingsProps> = ({ settings, onChange, onSave }) => {
  return (
    <div className="zenoh-settings">
      <h4>Настройки Zenoh подключения</h4>
      <div className="form-group">
        <label htmlFor="zenohHost">Zenoh Host:</label>
        <input
          type="text"
          id="zenohHost"
          name="host" // Важно для onChange
          value={settings.host}
          onChange={onChange}
          placeholder="IP адрес Zenoh bridge"
        />
      </div>
      <div className="form-group">
        <label htmlFor="zenohPort">Zenoh Port:</label>
        <input
          type="number" // Или text, если нужна валидация на уровне компонента
          id="zenohPort"
          name="port" // Важно для onChange
          value={settings.port}
          onChange={onChange}
          placeholder="Порт Zenoh"
        />
      </div>
      <div className="form-group">
        <label htmlFor="cmdVelTopic">Topic для команд:</label>
        <input
          type="text"
          id="cmdVelTopic"
          name="cmdVelTopic" // Важно для onChange
          value={settings.cmdVelTopic}
          onChange={onChange}
          placeholder="Топик команд скорости"
        />
      </div>
      <div className="form-group">
        <label htmlFor="statusTopic">Topic для статуса:</label>
        <input
          type="text"
          id="statusTopic"
          name="statusTopic" // Важно для onChange
          value={settings.statusTopic}
          onChange={onChange}
          placeholder="Топик статуса"
        />
      </div>
      <div className="form-group">
        <label htmlFor="videoStreamTopic">Topic для видеопотока:</label>
        <input
          type="text"
          id="streamTopic"
          name="streamTopic" // Важно для onChange
          value={settings.streamTopic}
          onChange={onChange}
          placeholder="Топик видеопотока"
        />
      </div>
      {/* Кнопка сохранения может быть добавлена здесь, если она часть этого блока */}
      {/* <button onClick={onSave}>Сохранить настройки</button> */}
    </div>
  );
};

export default ZenohSettings;